import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { invokePostService, setReRender, handleSnackBar, setFocusElement, setDashboardRefresh } from "../../../store/global/actions";
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { Grid } from '@material-ui/core';
import { sectionFormSchema, getSectionSchemaData, generateSectionSchema, sectionFormValidation } from '../../../services/entities/DashboardBuilder.js';
import { useHistory } from "react-router-dom";
import { getDetailsFromUrl } from '../../../services/blueprint';
import { editView } from "../../../store/views/actions";
import { getRightDrawerStatus } from '../../../store/global/selectors';
import { getViews } from '../../../store/views/selectors';
import './style.css';

const options = {
    form_name_root: "section_form",
    show_errors: "interaction",
    disable_array_add: false,
    disable_array_reorder: true,
    disable_properties: false,
    no_additional_properties: false,
    keep_oneof_values: false,
    disable_array_delete_all_rows: true,
    disable_array_delete_last_row: true,
}

export default function SectionForm({ action, onClose, selectedSection }) {
    const dispatch = useDispatch();
    const history = useHistory();

    const selectedView = useSelector(getViews);

    const { slug, blueprintId } = getDetailsFromUrl();
    const [schemaValues, setSchemaValues] = useState({});
    const [viewSchema, setViewSchema] = useState({});
    const [loading, setLoading] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [formData, setFormData] = useState({});
    const [editorObj, setEditorObj] = useState(null);

    
    useEffect(() => {
        setLoading(true);
        let schemaData = getSectionSchemaData(selectedSection);
        setViewSchema(sectionFormSchema);
        setSchemaValues(schemaData);
        setLoading(false);
    }, []);
    

    const sectionCustomFormValidation = (schema, value, path) => {
        const sections = selectedView?.view_schema?.map(item => item.name);
        return sectionFormValidation({ schema, value, path, sections, selectedSection })
    }



    const onChangeJsonEditor = (data, jsonEditor) => {
        setEditorObj(jsonEditor);
        setFormData(data);
    }


    const onSubmit = () => {
        const validationErrors = editorObj.validate();
        if (validationErrors.length > 0) {
            editorObj.showValidationErrors(validationErrors);
            return;
        }

        setIsUpdating(true);

        const sectionData = { name: formData.name, desc: formData.desc };
        if (formData.height !== '' && formData.height !== undefined && formData.width !== '' && formData.width !== undefined) {
            sectionData.dimensions = `${formData.width}x${formData.height}`;
        }


        if (action == "create") {
            const newSection = generateSectionSchema({ ...sectionData });
            const updatedView = {
                ...selectedView,
                view_schema: [
                    ...selectedView.view_schema,
                    newSection
                ]
            };
            dispatch(setDashboardRefresh({ type: "section", action: "create", entity: newSection }));
            handleViewUpdate(updatedView, newSection);
        } else if (action === 'edit') {
            const updatedSection = { ...selectedSection, ...sectionData };
            const editedSchema = selectedView.view_schema.map(item => { return item.id === updatedSection.id ? updatedSection : item; });
            const updatedView = {
                ...selectedView,
                view_schema: [...editedSchema]
            }
            dispatch(setDashboardRefresh({ type: "section", action: "edit", entity: updatedSection }));
            handleViewUpdate(updatedView, updatedSection);
        }
    }

    const handleViewUpdate = (updatedView, section) => {
        dispatch(invokePostService('updateView', { view: updatedView }, [selectedView?._id])).then(response => {
            setIsUpdating(false);
            if (response.status === true) {
                dispatch(editView(updatedView));
                if (action === 'create') {
                    dispatch(setFocusElement({ id: section.id, type: "section", action: "edit", name: section.name }))
                }
                dispatch(handleSnackBar({ open: true, message: `Section ${action === "create" ? "created" : "updated"}`, severity: 'success' }));
                if (action === "edit"){
                    dispatch(setFocusElement({ id: section.id, type: "section", action: "edit", name: section.name }))
                } 
            } else {
                if (response.code === 255) {
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    dispatch(setFocusElement({}))
                }
            }
        })
    }

    return (
        <>
            {!loading && Object.keys(viewSchema).length > 0 &&
                <JsonTableEditor options={options} key={selectedSection} schema={viewSchema} schemaValues={schemaValues} validation={sectionCustomFormValidation} onChangeJsonEditor={onChangeJsonEditor} editorId={"section_form"} />
            }
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel updateDisable={isUpdating || loading} content={isUpdating ? (action === "create" ? "Creating.." : "Updating..") : (action === "create" ? "Create" : "Update")} onUpdate={onSubmit} onCancel={onClose} />
            </Grid>
        </>
    )



}